import { Component, input } from '@angular/core';
import { DokaSpinner, SpinnerSize } from '@doka/angular-core';

@Component({
  selector: 'app-spinner',
  template: `<doka-spinner [size]="size()" />`,
  host: { class: 'flex justify-center items-center w-full h-full' },
  imports: [DokaSpinner],
})
export class SpinnerComponent {
  public readonly size = input<SpinnerSize>(SpinnerSize.Medium);
}
